module.exports = __webpack_public_path__ + "img/newLogo.a02dc716.svg";